/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Button, Col, Divider, Modal, Row, Tooltip } from 'antd';
import { sendDataPDFportfolio } from '../../../data/store/portfolio/portfolioActions';
import { PortfolioTableOptimal } from '../../../components/PortfolioTable/PortfolioTableOptimal';

import { ReactComponent as Pluse } from '../../../assets/cross-btn-icon.svg';
import { ReactComponent as Check } from '../../../assets/check-white-icon.svg';

import './style.scss';
import { numberWithSpacesInter } from '../../../helpers/formatInteger';
import { getClassCategoryArray } from '../../../hooks/getClassCategoryArray';
import ModalCreateReport from './ModalCreateReport';

const StepSuggestedPortfolio = ({
  userId,
  portfolioId,
  pdfSource,
  setPDFSource,
  optAlert,
  setOptAlert,
  setOptStart,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('');
  const history = useHistory();

  const [modalCancelVisible, setModalCancelVisible] = useState(false);
  const [modalFinishVisible, setModalFinishVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [tableColumns, setTableColumns] = useState();
  const [reportType, setReportType] = useState(null);

  const cashes = useSelector((state) => state.instrumentsReducer?.cashes?.list);
  const { assets } = useSelector((state) => state.instrumentsReducer);
  const { isLoading } = useSelector((state) => state.portfolioReducer);
  const precandidate = useSelector(
    (state) => state.portfolioReducer?.precandidate,
  );
  const cash_out_sek = useSelector(
    (state) =>
      state.portfolioReducer?.analyzedPortfolioDot?.transactions?.cash_out_sek,
  );
  const cash_target_sek = useSelector(
    (state) =>
      state.portfolioReducer?.analyzedPortfolioDot?.transactions
        ?.cash_target_sek,
  );

  useEffect(() => {
    if (optAlert?.flag) setModalCancelVisible(true);
  }, [optAlert]);

  const optimalPortfolio = sessionStorage.getItem('selectedPortfolio')
    ? JSON.parse(sessionStorage.getItem('selectedPortfolio'))
    : null;

  useEffect(() => {
    if (precandidate) {
      const data = precandidate?.contents.filter((i) => !i.is_excluded).slice();
      const forReport = {
        portfolio_cashes: precandidate?.cashes ?? [],
        portfolio_content: precandidate?.contents.filter((i) => !i.is_excluded),
      };
      setTableData(data);
      const assetClass = getClassCategoryArray(
        [forReport],
        cashes,
        assets,
        true,
      )
        ?.class.sort((a, b) => b.weight - a.weight)
        .map((i) => ({
          ...i,
          value: numberWithSpacesInter(i.value, 0),
          value_persent: Math.round(i.value_persent * 100) / 100,
          weight: i.weight.toFixed(2).replace('.', ','),
        }));
      const assetCategory = getClassCategoryArray(
        [forReport],
        cashes,
        assets,
        true,
      )
        ?.category.sort((a, b) => b.weight - a.weight)
        .map((i) => ({
          ...i,
          value: numberWithSpacesInter(i.value, 0),
          value_persent: Math.round(i.value_persent * 100) / 100,
          weight: i.weight.toFixed(2).replace('.', ','),
        }));
      setPDFSource({
        ...pdfSource,
        page4_asset_class: {
          ...pdfSource?.page4_asset_class,
          optimized_class: assetClass,
        },
        page5_category: {
          ...pdfSource?.page5_category,
          optimized_category: assetCategory,
        },
      });
    }
  }, [precandidate]);

  const cancelWithoutChange = () => {
    const path = optAlert.path;
    setOptStart(false);
    closeModal();
    history.push(path);
  };

  const handleReset = () => {
    setOptAlert({ flag: false, path: '' });
    setOptStart(false);
    history.push(`/accounts/${userId}/portfolio`, 'edit');
  };

  const handleBack = () => {
    dispatch({ type: 'CLEAR_PORTFOLIO_PRECANDIDATE' });
    history.goBack();
  };

  const closeModal = () => {
    setModalCancelVisible(false);
  };

  const closeFinishModal = () => {
    setModalFinishVisible(false);
  };

  const handleFinish = () => {
    setModalFinishVisible(true);
  };

  const cancelWithoutReport = () => {
    setModalFinishVisible(false);
    history.push(`/accounts/${userId}/portfolio`, 'edit');
  };

  const handleSaveReport = () => {
    const data = tableData
      ?.sort((a, b) => b.value - a.value)
      ?.map((row) => {
        return {
          name: row.name,
          value: numberWithSpacesInter(row.value, 0),
          weight: numberWithSpacesInter(row.current_weight_fin, 2),
          fee: numberWithSpacesInter(row.fee, 2),
          assetClass: row?.asset_class_name,
        };
      });
    const parts = {
      ...pdfSource,
      page8_header: {
        cash_remaining: numberWithSpacesInter(cash_target_sek, 0),
        cash_withdrawal: numberWithSpacesInter(cash_out_sek, 0),
      },
      page8_suggested_table: {
        data,
        total: numberWithSpacesInter(precandidate?.total_value, 0),
        fee: numberWithSpacesInter(precandidate?.total_fee, 2),
      },
    };

    setOptStart(false);
    setModalFinishVisible(false);
    dispatch(
      sendDataPDFportfolio({
        history,
        clientID: userId,
        portfolioId,
        array: {
          prospect_portfolio_id: optimalPortfolio.name,
          precandidate_portfolio_id: precandidate?.id,
          parts,
          report_id: reportType,
        },
      }),
    );
    setPDFSource(null);
  };

  return (
    <div className="optimization-component-wrapper transaction-page">
      <div className="top-btn-wrapper">
        <Button
          type="text"
          className="portfolio-cancel-btn"
          icon={<Pluse />}
          iconPosition="end"
          onClick={handleReset}
        >
          {t('CANCEL')}
        </Button>
        <Button className="optim-settings-btn" onClick={handleBack}>
          {t('BACK_TO_TRANSACTIONS')}
        </Button>
        <Button
          icon={<Check />}
          iconPosition="end"
          disabled={!optimalPortfolio?.name || isLoading}
          onClick={handleFinish}
          className="optim-continue-btn"
        >
          {t('FINISH')}
        </Button>
      </div>
      <div className="opt-charts-wrapper" id="pdf-part-6">
        <Row className="opt-title-wrap">
          <Col className="opt-title-column">
            <h2 className="opt-paper-title">{t('CASH_REMAINING')}</h2>
            <span className="holdings-value">
              {numberWithSpacesInter(cash_target_sek, 0)} kr
            </span>
          </Col>
          <Col className="opt-title-column">
            <h2 className="opt-paper-title">{t('CASH_WITHDRAWAL')}</h2>
            <span className="holdings-value">
              {numberWithSpacesInter(cash_out_sek, 0)} kr
            </span>
          </Col>
        </Row>
        <div className="">
          <h2 className="opt-block-title">{t('SUGGESTED_PORTFOLIO')}</h2>
        </div>
        <PortfolioTableOptimal
          optimalPortfolio={tableData}
          tableColumns={tableColumns}
          setTableColumns={setTableColumns}
        />
        <Row className="opt-total-wrap">
          <Col span={12} style={{ display: 'flex', alignItems: 'center' }}>
            <span className="holdings-text">{t('TOTAL')}</span>
          </Col>
          <Col span={12} className="holdings-value-wrapper">
            <span className="holdings-value">
              {numberWithSpacesInter(precandidate?.total_value, 0)} kr
            </span>
            <Tooltip
              placement="topLeft"
              overlayStyle={{ width: '100%', borderRadius: '14px' }}
              title={
                <span style={{ width: '100%', color: '#000000' }}>
                  {t('HOLDINGS_FEE_TOOLTOP')}
                </span>
              }
              color="white"
            >
              <span className="holdings-value-fee">
                {numberWithSpacesInter(precandidate?.total_fee, 2)}%
              </span>
            </Tooltip>
          </Col>
        </Row>
      </div>

      <Modal
        width={700}
        className="modal-content-paper"
        open={modalCancelVisible}
        onCancel={closeModal}
        footer={null}
        zIndex={1620}
      >
        <Row justify="start">
          <Col className="modal-title">{t('WARNING_OPT')}</Col>
        </Row>
        <Divider className="modal-divider" />
        <Row justify="start" className="modal-text-wrapper">
          <Col span={18}>
            <p className="modal-description">{t('WARNING_OPT_TEXT')}</p>
          </Col>
        </Row>

        <Row justify="end" style={{ marginTop: '50px' }}>
          <Col>
            <Button
              className="modal-action-btn cancel-btn"
              onClick={cancelWithoutChange}
            >
              {t('LEAVE_OPTIMIZATION_FLOW')}
            </Button>
            <Button
              style={{ marginLeft: '8px' }}
              className="modal-action-btn save-btn"
              onClick={closeModal}
            >
              {t('CONTINUE_OPTIMIZATION')}
            </Button>
          </Col>
        </Row>
      </Modal>
      <ModalCreateReport
        modalFinishVisible={modalFinishVisible}
        closeFinishModal={closeFinishModal}
        cancelWithoutReport={cancelWithoutReport}
        handleSaveReport={handleSaveReport}
        reportType={reportType}
        setReportType={setReportType}
      />
    </div>
  );
};

export default StepSuggestedPortfolio;

StepSuggestedPortfolio.propTypes = {
  userId: PropTypes.string,
  portfolioId: PropTypes.string,
  pdfSource: PropTypes.object,
  setPDFSource: PropTypes.func,
  settings: PropTypes.object,
  setOptimalPortfolio: PropTypes.func,
  optAlert: PropTypes.object,
  setOptAlert: PropTypes.func,
  setOptStart: PropTypes.func,
};
